<script lang="ts">
import { computed, defineComponent, ref } from 'vue';
import { useAngleStore } from '@/src/store/tools/angles';

export default defineComponent({
  setup() {
    const angleStore = useAngleStore();
    const editingId = ref<number | null>(null);
    const newName = ref('');

    const angles = computed(() => {
      return angleStore.angles;
    });

    function remove(id: number) {
      angleStore.removeAngle(id);
    }

    function hover(id: number | null) {
      angleStore.updateHoveredAngle(id); // Store the hovered angle
    }

    function startEditing(id: number, currentName: string) {
      editingId.value = id;
      newName.value = currentName;
    }

    function saveName(id: number) {
      if (newName.value.trim()) {
        angleStore.updateAngleName(id, newName.value);
      }
      editingId.value = null;
    }

    function cancelEditing() {
      editingId.value = null;
    }

    return {
      angles,
      remove,
      hover,
      editingId,
      newName,
      startEditing,
      saveName,
      cancelEditing,
    };
  },
});
</script>

<template>
  <v-list-item
    v-for="angle in angles"
    :key="angle.id"
    lines="two"
    @mouseenter="hover(angle.id)"
    @mouseleave="hover(null)"
    @dblclick="startEditing(angle.id, angle.name)"
  >
    <template #prepend>
      <v-icon class="tool-icon">mdi-angle-acute</v-icon>
    </template>
    <v-list-item-title v-bind="$attrs">
      <template v-if="editingId === angle.id">
        <v-text-field
          v-model="newName"
          dense
          @blur="saveName(angle.id)"
          @keydown.enter="saveName(angle.id)"
          @keydown.esc="cancelEditing"
        />
      </template>
      <template v-else>
        <span @click="startEditing(angle.id, angle.name)">
          {{ angle.name || 'Unnamed (Double-click)' }}
          <v-chip v-if="!angle.name" label small color="success" text-color="white">New</v-chip>
        </span>
      </template>
    </v-list-item-title>
    <v-list-item-subtitle>
      <v-row>
        <v-col>Angle: {{ angle.value }}</v-col>
      </v-row>
    </v-list-item-subtitle>
    <template #append>
      <v-row>
        <v-btn icon="mdi-delete" variant="text" @click="remove(angle.id)">
          <v-icon>mdi-delete</v-icon>
          <v-tooltip location="top" activator="parent">Delete</v-tooltip>
        </v-btn>
      </v-row>
    </template>
  </v-list-item>
</template>

<style src="@/src/components/styles/utils.css"></style>

<style scoped>
.empty-state {
  text-align: center;
}

.color-dot {
  width: 24px;
  height: 24px;
  background: yellow;
  border-radius: 16px;
}

.tool-icon {
  margin-inline-end: 12px;
}
</style>